import { useEffect, useRef } from "react";
import "./DownloadApp.css";

const PLAY_STORE_PACKAGE = "com.bolo.india";
const PLAY_STORE_URL = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE}`;
// Chrome on Android launches the Play Store app directly for an intent://
// URL instead of opening a browser tab like market:// sometimes does.
const PLAY_STORE_INTENT_URL = `intent://details?id=${PLAY_STORE_PACKAGE}#Intent;scheme=market;package=com.android.vending;end`;
const APP_STORE_URL =
  "https://apps.apple.com/in/app/bolo-india-media/id6781571060";

function getPlatform() {
  const ua = navigator.userAgent || "";
  const platformStr = navigator.platform || "";

  if (/Android/i.test(ua)) return "android";

  // Covers iPhone/iPad/iPod, real Macs, and iPadOS 13+ Safari (which reports
  // itself as "MacIntel" but exposes touch support).
  const isAppleMobile = /iPhone|iPad|iPod/i.test(ua);
  const isMac = /Mac/i.test(platformStr) || /Macintosh/i.test(ua);
  const isIpadOnMacUA = isMac && navigator.maxTouchPoints > 1;
  if (isAppleMobile || isMac || isIpadOnMacUA) return "apple";

  return "other";
}

export default function DownloadApp() {
  const platform = useRef(getPlatform()).current;
  const isAndroid = platform === "android";
  const isApple = platform === "apple";
  const storeUrl = isApple ? APP_STORE_URL : PLAY_STORE_URL;

  // On Android, hand off straight to the Play Store app via an intent:// URL;
  // if it's not handled (no Play Store app), fall back to the https URL so
  // the page still redirects instead of doing nothing.
  //
  // NOTE: Chrome only honors an intent:// navigation reliably when it is a
  // direct `window.location.href` assignment (not a synthetic <a> click, and
  // not one fired from deep inside an async/timer callback chain — Chrome's
  // navigation-throttling can silently downgrade those to a normal page
  // load, which is what looks like "it just opens a tab").
  function goToStore() {
    if (isAndroid) {
      let fellBack = false;
      const fallback = () => {
        if (fellBack) return;
        fellBack = true;
        window.location.href = PLAY_STORE_URL;
      };
      document.addEventListener(
        "visibilitychange",
        function onHide() {
          if (document.hidden) {
            fellBack = true;
            document.removeEventListener("visibilitychange", onHide);
          }
        },
        { once: true },
      );

      window.location.href = PLAY_STORE_INTENT_URL;
      setTimeout(fallback, 1500);
    } else {
      window.location.href = storeUrl;
    }
  }

  useEffect(() => {
    goToStore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const storeName = isApple ? "App Store" : "Play Store";

  return (
    <div className="download-app">
      <p className="download-app__hint">
        Redirecting to the {storeName}… If nothing happens,{" "}
        <a
          className="download-app__link"
          href={storeUrl}
          onClick={(e) => {
            if (isAndroid) {
              e.preventDefault();
              goToStore();
            }
          }}
        >
          tap here
        </a>
        .
      </p>
    </div>
  );
}
